import { ChangeEventHandler } from 'react';

import { FormControl, TextField } from '@mui/material';
import { editDrawerTextFieldStyles } from 'common/utils/StyleHelpers';

export type ClaimValueCustomDateTimeFieldProps = {
    value: string,
    changeHandler: ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>,
    type?: React.InputHTMLAttributes<unknown>['type'],
    dataTestId?: string,
    hasError?: boolean
};

export function ClaimValueCustomDateTimeField({
    value,
    changeHandler,
    type,
    dataTestId,
    hasError
}: Readonly<ClaimValueCustomDateTimeFieldProps>) {
    return (
        <FormControl>
            <TextField
                sx={editDrawerTextFieldStyles(hasError)}
                label="Claim Value"
                placeholder="Type Claim Value"
                value={value}
                onChange={changeHandler}
                type={type}
                InputLabelProps={{ shrink: true }}
                data-testid={dataTestId}
            />
        </FormControl>
    );
}
